import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  inviteEvaluators: {
    id: `app.containers.ScorecardModals.inviteEvaluators`,
    defaultMessage: 'Invite evaluators',
    description: 'Title of the modal for inviting scorecard evaluators',
  },
  yourScorecard: {
    id: `app.containers.ScorecardModals.yourScorecard`,
    defaultMessage: 'Your scorecard',
    description:
      'Tag on the results table column holding the signed-in evaluator',
  },
  invitedDate: {
    id: `app.containers.ScorecardModals.invitedDate`,
    defaultMessage: 'Invited {date}',
    description:
      'Date under an evaluator who has not submitted their scorecard yet',
  },
  showMore: {
    id: `app.containers.ScorecardModals.showMore`,
    defaultMessage: 'Show more',
    description: 'Toggle that expands a clamped scorecard note',
  },
  showLess: {
    id: `app.containers.ScorecardModals.showLess`,
    defaultMessage: 'Show less',
    description: 'Toggle that collapses an expanded scorecard note',
  },
  resultsLoadFailed: {
    id: `app.containers.ScorecardModals.resultsLoadFailed`,
    defaultMessage:
      "We couldn't load the scorecard results. Refresh the page or try again later.",
    description: 'Error shown when the scorecard results fail to load',
  },
});
